import { admin_bp, adminRoute } from "@/config/roles";
import { isAuthorized } from "@/utils/authToken";

export const ADMIN_BASE_REDIRECT_ROUTE = isAuthorized(admin_bp)
  ? `${adminRoute}/reports`
  : `${adminRoute}/practice`;
